/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createReasonCode } from '../fn/admin-reason-codes/create-reason-code';
import { CreateReasonCode$Params } from '../fn/admin-reason-codes/create-reason-code';
import { deleteReasonCode } from '../fn/admin-reason-codes/delete-reason-code';
import { DeleteReasonCode$Params } from '../fn/admin-reason-codes/delete-reason-code';
import { listReasonCodes } from '../fn/admin-reason-codes/list-reason-codes';
import { ListReasonCodes$Params } from '../fn/admin-reason-codes/list-reason-codes';
import { ReasonCode } from '../models/reason-code';
import { updateReasonCode } from '../fn/admin-reason-codes/update-reason-code';
import { UpdateReasonCode$Params } from '../fn/admin-reason-codes/update-reason-code';

@Injectable({ providedIn: 'root' })
export class AdminReasonCodesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminReasonCodeControllerListReasonCodes()` */
  static readonly AdminReasonCodeControllerListReasonCodesPath =
    '/admin/reason-codes/{entityClass}/{entityId}/{primaryType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReasonCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReasonCodes$Response(
    params: ListReasonCodes$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ReasonCode>>> {
    return listReasonCodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReasonCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReasonCodes(params: ListReasonCodes$Params, context?: HttpContext): Observable<Array<ReasonCode>> {
    return this.listReasonCodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReasonCode>>): Array<ReasonCode> => r.body)
    );
  }

  /** Path part for operation `adminReasonCodeControllerCreateReasonCode()` */
  static readonly AdminReasonCodeControllerCreateReasonCodePath = '/admin/reason-codes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReasonCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReasonCode$Response(
    params: CreateReasonCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ReasonCode>> {
    return createReasonCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReasonCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReasonCode(params: CreateReasonCode$Params, context?: HttpContext): Observable<ReasonCode> {
    return this.createReasonCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReasonCode>): ReasonCode => r.body)
    );
  }

  /** Path part for operation `adminReasonCodeControllerUpdateReasonCode()` */
  static readonly AdminReasonCodeControllerUpdateReasonCodePath = '/admin/reason-codes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReasonCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReasonCode$Response(
    params: UpdateReasonCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ReasonCode>> {
    return updateReasonCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReasonCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReasonCode(params: UpdateReasonCode$Params, context?: HttpContext): Observable<ReasonCode> {
    return this.updateReasonCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReasonCode>): ReasonCode => r.body)
    );
  }

  /** Path part for operation `adminReasonCodeControllerDeleteReasonCode()` */
  static readonly AdminReasonCodeControllerDeleteReasonCodePath = '/admin/reason-codes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteReasonCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReasonCode$Response(
    params: DeleteReasonCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteReasonCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteReasonCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReasonCode(params: DeleteReasonCode$Params, context?: HttpContext): Observable<void> {
    return this.deleteReasonCode$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
